import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Features from '../components/Features';
import Tools from '../components/Tools';
import Table from '../components/Table';
import Testimonials from '../components/Testimonials';
import Faq from '../components/Faq';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { TRACKING_API_URL } from '../config';

export default function LawxLegaltechBrasil() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Track PageView event with UTM parameters
    const utmSource = searchParams.get('utm_source');
    const trackingData = {
      event_name: 'PageView',
      page: '/2024/08/29/lawx-legaltech-brasil/',
      ...(utmSource && { utm_source: utmSource })
    };

    fetch(TRACKING_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(trackingData),
    })
      .then(() => console.log('PageView event tracked for slug page'))
      .catch((error) => console.error('Error tracking PageView event:', error));
  }, [searchParams]);

  return (
    <div className="bg-[#081428] text-white min-h-screen">
      <SEO
        title="LawX Legaltech Brasil"
        description="LawX é uma das principais legaltechs do Brasil, oferecendo inteligência artificial para advogados e transformando a prática jurídica."
        keywords="LawX, legaltech Brasil, legaltech, startup jurídica, inovação jurídica"
        url="/2024/08/29/lawx-legaltech-brasil"
        type="article"
      />
      <Navbar />
      <Hero />
      <Features />
      <Tools />
      <Table />
      <Testimonials />
      <Faq />
      <Footer />
    </div>
  );
} 